import React from 'react';

const ProgressCircle = ({ percent, strokeColor = '#3385ff', size = 40 }) => {
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg 
        className="transform -rotate-90" 
        width={size} 
        height={size} 
        viewBox="0 0 40 40"
      >
        {/* Background circle */}
        <circle
          cx="20"
          cy="20"
          r={radius}
          // stroke="#f3f4f6"
          stroke="#ebf0fa"
          strokeWidth="3"
          fill="transparent"
          // className="opacity-20"
        />
        {/* Progress circle */}
        <circle
          cx="20"
          cy="20"
          r={radius}
          stroke={strokeColor}
          strokeWidth="3"
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          className="transition-all duration-300 ease-in-out"
        />
      </svg>
      <span className="absolute text-[8px] font-medium text-gray-600">
        {percent}%
      </span>
    </div>
  );
};

export default ProgressCircle;
